import { FEATURES, MODAL, SEARCH_GROUPS } from '@constants/Text'
import { lazyLoadView } from '@utils/LazyLoad'

export default [
  {
    path: '/captable',
    name: FEATURES.CAPTABLE,
    redirect: '/captable/geral',
    meta: {
      can_show: FEATURES.CAPTABLE,
      search: {
        title: 'Partnership',
        description: 'Sociedade, contratos e kit societário do escritório',
        keywords: [
          'partnership',
          'sociedade',
          'sócios',
          'captable',
          'contratos',
        ],
        icon: 'receipt-items',
        group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
      },
    },
    component: () =>
      lazyLoadView(
        import('@modules/captable/views/captable-nav-bar/captable-nav-bar.vue')
      ),
    children: [
      {
        path: 'geral',
        name: 'captable.visao_geral',
        meta: {
          can_show: FEATURES.CAPTABLE,
          search: {
            title: 'Partnership — Visão Geral',
            description: 'Visão geral da estrutura societária',
            keywords: ['partnership', 'visão geral', 'sociedade', 'resumo'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/captable/views/overview-legal/view-overview-legal.vue'
            )
          ),
      },
      {
        path: 'partnership',
        name: 'captable.partnership',
        meta: {
          can_show: FEATURES.CAPTABLE,
          search: {
            title: 'Partnership — Sócios',
            description: 'Distribuição societária e participação de sócios',
            keywords: [
              'partnership',
              'sócios',
              'participação',
              'quotas',
              'equity',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/captable/views/captable-partnership/captable-partnership.vue'
            )
          ),
      },

      {
        path: 'controle-partnership',
        name: 'captable.controle_partnership',
        meta: {
          can_show: FEATURES.CAPTABLE,
          search: {
            title: 'Partnership — Controle',
            description: 'Controle e acompanhamento do partnership',
            keywords: [
              'partnership',
              'controle',
              'acompanhamento',
              'sociedade',
            ],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
            actions: [
              {
                id: 'emitir-cotas',
                title: 'Emitir cotas',
                keywords: [
                  'emitir cotas',
                  'adicionar compra',
                  'adicionar venda',
                  'quotas',
                  'ações',
                ],
                to: { name: 'captable.controle_partnership' },
                modal: MODAL.MODAL_CREATE_QUOTAS,
              },
              {
                id: 'notificar-pagamentos-atraso',
                title: 'Notificar pagamentos em atraso',
                keywords: [
                  'atraso',
                  'inadimplência',
                  'cobrança',
                  'notificar sócio',
                  'notificar pagamentos',
                ],
                to: { name: 'captable.controle_partnership' },
                modal: MODAL.MODAL_LATE_NOTIFY,
              },
            ],
          },
        },
        component: () =>
          lazyLoadView(
            import(
              '@modules/captable/views/control-partnership/view-control-partnership-overview.vue'
            )
          ),
      },

      {
        path: 'contratos',
        name: 'captable.contracts',
        meta: {
          can_show: FEATURES.DOCS,
          search: {
            title: 'Partnership — Contratos',
            description: 'Contratos societários e documentos',
            keywords: ['contratos', 'documentos', 'partnership', 'jurídico'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
            actions: [
              {
                id: 'novo-contrato-societario',
                title: 'Novo contrato societário',
                keywords: [
                  'novo contrato',
                  'iniciar documentos',
                  'contrato societário',
                  'documentos',
                ],
                to: { name: 'captable.contracts' },
                modal: MODAL.DOCS_SAVE_DOCUMENTS,
              },
            ],
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/captable/views/contracts/view-contracts.vue')
          ),
      },
      {
        path: 'modelos',
        name: 'captable.templates',
        meta: {
          can_show: FEATURES.MODELOS,
          search: {
            title: 'Partnership — Modelos',
            description: 'Modelos de documentos societários',
            keywords: ['modelos', 'templates', 'documentos', 'partnership'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@src/modules/documents/views/documents-templates')
          ),
      },
      {
        path: 'gerenciar/:id_document',
        name: 'captable.manager.document',
        component: () =>
          lazyLoadView(
            import('@src/modules/documents/views/documents-document')
          ),
      },
      {
        path: 'kit-socios',
        name: 'captable.kit_partners',
        meta: {
          can_show: FEATURES.KIT_SOCIETARIO,
          search: {
            title: 'Partnership — Kit Societário',
            description: 'Kit de documentos societários dos sócios',
            keywords: ['kit societário', 'sócios', 'documentos', 'partnership'],
            group: SEARCH_GROUPS.GESTAO_ESCRITORIOS,
          },
        },
        component: () =>
          lazyLoadView(
            import('@modules/captable/views/kit-partners/view-kit-partners.vue')
          ),
      },
    ],
  },
]
